import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

function AuthLoadingFallback() {
  return (
    <div className="authShell">
      <div className="authCard authStatusCard">
        Loading...
      </div>
    </div>
  );
}

export default function RequireAuth({ children }: { children: ReactNode }) {
  const { authPhase, status, isAuthenticated, isInitializing, isAuthProcessing } = useAuth();

  if (
    isInitializing
    || isAuthProcessing
    || authPhase === "booting"
  ) {
    console.info("[auth-debug]", {
      area: "require-auth",
      event: "wait",
      authPhase,
      status,
      isAuthenticated,
      isInitializing,
      isAuthProcessing,
    });
    return <AuthLoadingFallback />;
  }

  if (authPhase === "unauthenticated" || authPhase === "error" || status === "anon" || !isAuthenticated) {
    console.info("[auth-debug]", {
      area: "require-auth",
      event: "navigate",
      target: "/login",
      authPhase,
      status,
      isAuthenticated,
    });
    return <Navigate to="/login" replace />;
  }
  if (status === "needs-mfa") {
    console.info("[auth-debug]", {
      area: "require-auth",
      event: "navigate",
      target: "/mfa",
      authPhase,
      status,
      isAuthenticated,
    });
    return <Navigate to="/mfa" replace />;
  }
  return <>{children}</>;
}
